import { Fragment } from "react";
import "./Testimonial.css";
import testimonial from "../../assets/images/landing/testimonial.png";

// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const Testimonial = () => {
  const testimonialData = [
    {
      left: {
        text: "This team exceeded our expectations. Fast and smooth delivery.",
        name: "Priya R",
        role: "Startup Founder",
      },
      right: {
        text: "Outstanding support and quality. Highly recommended.",
        name: "Madhan K",
        role: "Business Owner",
      },
    },
    {
      left: {
        text: "Professional work and on-time delivery. Really impressed.",
        name: "Aishwarya",
        role: "Designer",
      },
      right: {
        text: "Great communication and modern UI implementation.",
        name: "Suresh V",
        role: "Entrepreneur",
      },
    },
    {
      left: {
        text: "Top-notch service and smooth integration.",
        name: "Sandhiya",
        role: "Marketing Lead",
      },
      right: {
        text: "They solved problems quickly and cleanly.",
        name: "Karthik",
        role: "Product Manager",
      },
    },
  ];

  return (
    <Fragment>
      <section className="testimonial-section">
        <div className="container">
          <div
            className="section-title"
            data-aos="fade-down"
            data-aos-duration="800"
          >
            <div className="text-uppercase">Testimonial</div>
            <h4 className="text-uppercase">We are trusted by our clients</h4>
          </div>

          <div className="testimonial-slider-container">
            {/* Constant Center Glow */}
            <div className="center-circle">
              <div className="center-circle">
                <img
                  src={testimonial}
                  loading="lazy"
                  alt="testimonial-theme"
                  className="center-img"
                />
              </div>
            </div>

            <Swiper
              modules={[Autoplay]}
              pagination={{ clickable: true }}
              autoplay={{ delay: 4000 }}
              loop={true}
              dot={false}
              
            >
              {testimonialData.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="testimonial-layout">
                    <div className="testimonial-card left-card">
                      <p>"{item.left.text}"</p>
                      <h5>— {item.left.name}</h5>
                      <span>{item.left.role}</span>
                    </div>
                    <div className="testimonial-card right-card">
                      <p>"{item.right.text}"</p>
                      <h5>— {item.right.name}</h5>
                      <span>{item.right.role}</span>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Testimonial;
